<div class="expected-box" [ngClass]="currentChip && kind !== '3a' ? 'yellow' : 'blue'">
  <p class="title">
    <ng-container *ngIf="kind !== '3a'; else account3a">
      {{
        (currentChip ? 'sp.revamp.assetGraph.expectedReturn.total' : 'sp.revamp.assetGraph.expectedReturn.title')
          | translate: { estimatedPeriod: estimatedPeriod }
      }}
    </ng-container>
    <ng-template #account3a>{{ 'sp.revamp.3a.expected.total' | translate }}</ng-template>
    <app-ui-tooltip
      [content]="
        'sp.revamp.infoTooltip.balancedRisk' | translate: { risk_level: ('sp.revamp.assetGraph.riskLevel.' + riskLevel | translate) }
      "
      color="grey"
      size="small"
    ></app-ui-tooltip>
  </p>
  <p class="funds" *ngIf="estimatedValues?.expected">
    <span class="currency">{{ customerInvestment.currency }}</span>
    {{ (currentChip && kind !== '3a' ? estimatedValues.expectedWithout : estimatedValues.expected) | translateNumber: language }}
  </p>
</div>
<div class="expected-box">
  <p class="title">
    {{
      (kind === '3a' ? 'sp.revamp.3a.deposits.total' : 'sp.revamp.assetGraph.totalDeposits')
        | translate: { estimatedPeriod: estimatedPeriod }
    }}
  </p>
  <p class="funds">
    <span class="currency">{{ customerInvestment.currency }}</span>
    {{ totalDeposit | translateNumber: language }}
  </p>
</div>
